import React from "react";
import classNames from 'classnames';

import { ReactComponent as CloseIcon } from 'Icons/closeFilled.svg'
import { ReactComponent as TrashIcon } from 'Icons/delete.svg';
import { ReactComponent as RightArrow } from 'Icons/rightarrow.svg'
import rfq from "Reducers/rfq";
import Pdf from "react-to-pdf";
// import PRFormat from "Components/PRFormat";
import Upload from 'Components/Upload';
import { isAdaniWilmar } from "Utils/index";

const pdfRef = React.createRef();

const RFQBottomSticky = ({setNextView, setPreviousView, activeView, saveAndClose, discardRfq, viewMode, disableSubmitTrips, toggleConfirmation, serviceType, addCourierTrips, rfqType, addingTrip, rfq, warehouseTripsFilled, procurementList, uploadExistingTripsRemarks, downloadExistingTripsRemarks }) => {
    const nextDisabled = rfq.type === 8 && !(rfq.rfqDetails.contractTenureTo && rfq.biddingDetails.to && (rfq.deliveryDays || {}).value && (rfq.deliveryDays || {}).unit && (rfq.biddingDetails || {}).paymentTerms && (rfq.rfqDetails || {}).serviceModeName) || '';
    return (
        <div className={"pf box-shadow ht-60 bg-white b-0 col-1 z-501"}>
            <div className="container col-1 flex flex-middle flex-between row-100">
                <div className="flex flex-middle">
                    {activeView > 1  && <button className="fbutton previous" onClick={setPreviousView}><RightArrow className="mr-10" transform="rotate(180)" fill={'#597EF7'}/> Previous</button>}
                    {!viewMode && <div className="flex flex-middle curP loi-cancelled-color ml-20" onClick={discardRfq}>
                        <TrashIcon className="wt-15 ht-15"/>
                        <span className="pl-10 fBold loi-cancelled-color fs-16">Discard RFQ </span>
                    </div>}
                </div>
                <div className="flex flex-middle">
                    {!viewMode && <div className=" mr-30 curP fbutton" onClick={saveAndClose}>
                        <span className="pl-10 fBold theme-color fs-16" >Save & Close </span>
                    </div>}
                    {activeView < 2  && <button className="fbutton next" onClick={setNextView}>Next<RightArrow className="ml-10"/></button>}
                    
                    {activeView === 2 && !viewMode &&  <button className={classNames("fbutton next", { "curNA disableT1": disableSubmitTrips })} onClick={setNextView} disabled={disableSubmitTrips}>Proceed to Preview</button>}
                    {activeView === 3 && <button className={classNames("fbutton next", { "bg-gray curNA": disableSubmitTrips })} onClick={toggleConfirmation} disabled={disableSubmitTrips}>Submit RFQ</button>}
                </div>
         </div>
      </div>
   );
};

export default RFQBottomSticky;